import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const scheduleUnitCancellation = async (unitId: string, cancelDate: string): Promise<boolean> =>
  axios.post(`/unit/scheduleunitcancellation`, { unitId, cancelDate }).then((res) => res?.data?.result)

type Props = {
  unitId: string
  cancelDate: string
}

export const useScheduleUnitCancellation = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['scheduleUnitCancellation'],
    mutationFn: ({ unitId, cancelDate }: Props) => scheduleUnitCancellation(unitId, cancelDate),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Scheduled cancellation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to schedule cancellation, please try again.')
      }
    },
    throwOnError: false
  })
